<template>
  <v-card
    hover
    shaped
    @dragstart.stop.prevent="dragStart"
    :draggable="!dragging"
    :style="draggingSelf ? 'opacity: 0.3;' : null"
  >
    <v-card-text class="pb-2">
      <v-row class="px-2">
        <v-col style="font-size: 19px;" class="grey--text text--darken-3">
          <content-editor
            :value="{ html: page.title }"
            ref="titleEditor"
            @input="updatePageTitle({ pageId: page.id, title: $event })"
            @mousedown.stop.prevent
            style="cursor: text;"
            :preventTab="true"
            class=""
            :disabled="!userCanEdit"
            placeholder="Untitled Page"
            allowTraversal
            :emitText="true"
          ></content-editor>
        </v-col>
        <v-btn icon class="shrink"><v-icon>more_vert</v-icon></v-btn>
      </v-row>
      <v-row class="px-2">
        <v-col class="v-card__subtitle pt-0">
          <content-editor
            :value="{ html: page.description }"
            ref="descriptionEditor"
            @input="updatePageDescription({ pageId: page.id, description: $event })"
            @mousedown.stop.prevent
            style="cursor: text;"
            :preventTab="true"
            class=""
            :disabled="!userCanEdit"
            placeholder="Add a page description..."
            allowTraversal
            :emitText="true"
          ></content-editor>
        </v-col>
      </v-row>
      <!-- <v-row>
        <v-col class="py-0">
          <question-answer :question="page" :showText="false" class="mb-1"></question-answer>
        </v-col>
      </v-row> -->
      <!-- <v-row>
        <v-col class="py-0">
          <v-btn text @click="setSelectedPageId(page.id)">Open Page</v-btn>
        </v-col>
        <v-btn icon cols="1" @click.stop="addNewChild()" @mousedown.stop>
          <v-icon>
            add
          </v-icon>
        </v-btn>
      </v-row> -->
    </v-card-text>
    <v-col cols="12" class="pt-0">
      <v-divider></v-divider>
      <v-btn v-if="!noteCards.length" small block text color="grey">Add Research Card</v-btn>
      <v-list dense v-else class="pb-0">
        <note-card-list-item
          v-for="(card, index) in noteCards.slice(0, 3)"
          :key="card.id"
          :page="page"
          :card="card"
          :users="assignedUsers"
        ></note-card-list-item>
        <!-- <v-list-item v-for="(card, index) in noteCards.slice(0, 3)" :key="card.id">
          <v-list-item-icon class="mr-2">
            <v-icon :color="noteStatuses[card.state || 0].color">
              {{ noteStatuses[card.state || 0].icon }}
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <content-editor
              :value="{ html: card.title }"
              @input="
                updateCardTitle({
                  pageId: page.id,
                  cardId: card.id,
                  title: $event
                })
              "
              @mousedown.stop.prevent
              style="cursor: text; width: 100%;"
              :ref="card.id"
              class=""
              placeholder="Untitled Page"
              allowTraversal
              :emitText="true"
              :preventTab="true"
              @keyDownLastLine="traverseNoteCards({ direction: 'down', event: $event, index })"
              @keyUpFirstLine="traverseNoteCards({ direction: 'up', event: $event, index })"
              @keyEnter=""
              @keyShiftTab=""
            ></content-editor>
          </v-list-item-title>
          <v-list-item-icon
            v-for="(item, index) in assignedUsers[card.id]"
            :key="item.id"
            :class="{ 'mx-0': true, 'pl-1': !index }"
          >
            <user-avatar size="20px" :avatarUrl="item.avatar"></user-avatar>
          </v-list-item-icon>
        </v-list-item> -->
      </v-list>
      <v-expand-transition>
        <v-list v-show="showAll" dense class="pt-0">
          <note-card-list-item
            v-for="(card, index) in noteCards.slice(3, noteCards.length)"
            :key="card.id"
            :page="page"
            :card="card"
            :users="assignedUsers"
          ></note-card-list-item>
        </v-list>
      </v-expand-transition>
      <v-list-item
        v-if="noteCards.length > 3"
        @click.stop="showAll = !showAll"
        @mousedown.stop
        key="newCard"
        style="color: rgba(0, 0, 0, 0.5) !important; font-size: 0.8em;"
        ><v-icon small class="mr-2" :style="showAll ? 'transform: rotate(180deg)' : null">
          keyboard_arrow_down
        </v-icon>
        <span v-if="!showAll">Show all {{ noteCards.length }} cards</span>
        <span v-else>Collapse cards</span>
      </v-list-item>
    </v-col>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text @click="setSelectedPageId({ page: page.id })">Open Page</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import QuestionAnswer from '../../QuestionAnswer';
import ContentEditor from '@/components/ContentEditor';
import NoteCardListItem from './NoteCardListItem';

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  props: ['page'],
  components: { QuestionAnswer, ContentEditor, NoteCardListItem },
  data() {
    return {
      expand: false,
      draggingSelf: false,
      showAll: false
    };
  },
  computed: {
    ...mapState('views/context', ['selectedPageId', 'focusTo', 'showResourcePanel']),
    ...mapState('pages', ['pages']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapGetters('context', ['questions', 'userCanEdit']),
    ...mapGetters('workspaces', ['currentWorkspace']),
    assignedUsers() {
      const result = {};
      this.noteCards.forEach(c => {
        const userIds = c.assignedTo;
        if (userIds && this.currentWorkspace.members) {
          const userProfiles = userIds.map(u => this.currentWorkspace.members[u]);
          result[c.id] = userProfiles;
        } else {
          result[c.id] = [];
        }
      });
      return result;
    },
    noteCards() {
      const page = this.pages[this.page.id];
      const cards = page.noteCards;
      return Object.values(cards)
        .filter(b => !b.toDelete)
        .sort((a, b) => {
          if (a.order > b.order) {
            return 1;
          } else {
            return -1;
          }
        });
    }
    // childQuestions() {
    //   const questions = this.noteCards.filter(b => b.content && b.content.noteType == 'question');
    //   return questions;
    // }
  },
  watch: {
    dragging: function(n) {
      if (!n) {
        this.draggingSelf = false;
      }
    }
  },
  methods: {
    ...mapMutations('views/context', ['setSelectedPageId']),
    ...mapMutations('components/dragdrop', ['setDragPosition', 'updateDraggedData']),
    ...mapActions('context', ['updatePageTitle']),
    ...mapActions('pages', [
      'addNoteBlock',
      'updateNoteBlockHTML',
      'updatePageTitle',
      'updatePageDescription',
      'updateCardTitle',
      'addCard'
    ]),
    focusTitle() {
      this.$refs.titleEditor.focus();
    },
    async addNewChild(currentIndex) {
      let order = this.noteCards.length;
      if (currentIndex != undefined) {
        order = currentIndex + 1;
      }
      const id = await this.addCard({
        title: '',
        order,
        summary: '',
        pageId: this.page.id
      });
      this.$nextTick(() => {
        this.$refs[id][0].focus();
      });
    },
    traverseNoteCards({ event, direction, index }) {
      const prevLeft = event.bounds ? event.bounds.left : 0;
      const adjust = direction == 'up' ? -1 : 1;
      const target = this.noteCards[index + adjust];
      if (target) {
        this.$refs[target.id][0].setCaret({ prevLeft, direction });
      }
    },
    dragStart(event) {
      const ids = [this.page.id];
      const element = this.$el;
      const shift = {
        x: event.clientX - element.getBoundingClientRect().left,
        y: event.clientY - element.getBoundingClientRect().top
      };
      // get the element and shift positions for dragHelper
      let html = element.innerHTML;

      //  Build the html drag element
      // let allIds = ids;
      // if (this.selectedNoteBlocks && this.selectedNoteBlocks.includes(ids[0])) {
      //   //  Drag all the selected note blocks
      //   allIds = this.selectedNoteBlocks;
      // }
      // allIds.forEach(i => {
      //   html += this.$refs[i][0].$el.innerHTML;
      // });

      // update drag data
      const dragObject = {
        element,
        shift,
        html,
        ids,
        items: [this.page],
        types: ['page'],
        parent: {
          id: this.page.section,
          type: 'section'
        }
      };
      console.log(dragObject);
      //  first set initial drag position
      const { x, y } = event;
      this.setDragPosition({ x, y });
      //  now set drag content
      this.updateDraggedData(dragObject);
      this.draggingSelf = true;
    }
  }
};
</script>

<style></style>
